<template>
  <div id="app"  :class="$mq">
    <header id="app-header">
      <div>
        <img id="flowbird-logo" src="./assets/flowbird-logo.png" alt="">
        <div id="nav" v-if="$mq === 'desktop'">
          <router-link class="nav-buttons" :to="{name: 'Receipt'}" exact> {{$t('buttons.receipt')}} </router-link>
          <router-link class="nav-buttons" :to="{name: 'TransactionLookup'}"> {{$t('buttons.transaction_lookup')}} </router-link>
          <LocaleSwitcher id="locale-switcher"/>
        </div>
      </div>
    </header>

    <section id="content">
      <div id="image-section" v-show="$mq !== 'mobile'">
        <img id="city-image" src="./assets/illustration2.svg" alt="">
      </div>
      <div id="content-section">
        <router-view/>
      </div>
    </section>

    <footer>
      <div id="footer-content">
        <div id="address">
          <div class="">
            <h2 v-if="$mq === 'desktop'">FLOWBIRD, <small>Urban Intelligence</small></h2>
            <h3 v-else>FLOWBIRD, <small>Urban Intelligence</small></h3>
            <p>40 Twosome Drive - Unit 7</p>
            <p>Moorestown, NJ 08057</p>
          </div>
        </div>

        <div id="links">
          <ul class="footer-menu-list">
            <li class="">
              <a href="" class="">{{$t('privacy_policy')}}</a>
            </li>
            <li class="">
              <a href="" class="">{{$t('terms')}}</a>
            </li>
            <li class="">
              <a href="" class="">{{$t('media')}}</a>
            </li>
          </ul>
        </div>

        <div id="media">
          <p class="footer-networks__info">{{$t('follow_us')}}</p>
          <div class="footer-networks__item">
            <a href="https://plus.google.com/107173545494360706480/posts" target="_blank" class="footer-networks__link">
              <i class="fab fa-google-plus-square"></i>
            </a>
          </div>
          <div class="footer-networks__item">
            <a href="https://twitter.com/FlowbirdAmerica" target="_blank" class="footer-networks__link">
              <i class="fab fa-twitter"></i>
            </a>
          </div>
          <div class="footer-networks__item">
            <a href="https://vimeo.com/parkeon/videos" target="_blank" class="footer-networks__link">
              <i class="fab fa-vimeo-square"></i>
            </a>
          </div>
          <div class="footer-networks__item">
            <a href="https://www.linkedin.com/company/flowbirdamerica" target="_blank" class="footer-networks__link">
              <i class="fab fa-linkedin"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import LocaleSwitcher from "./components/LocaleSwitcher";
import {en, es} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'App',
  components: {LocaleSwitcher},
  computed: {
    dateLocale () {
      let locales = {
        'en': en,
        'es': es,
      }
      return locales[this.$i18n.locale]
    }
  }
}
</script>

<style>

  footer {
    height: 100px;
    width: 100%;
    color: white;
    background: #ba4c3e;
    position: fixed;
    bottom: 0;
    padding: 0 20px;
    box-sizing: border-box;
  }

  input:disabled {
    background-color: white;
    cursor: not-allowed;
  }

  input:disabled::placeholder {
    color: grey;
  }

  input:not([type=checkbox]):not([type=radio]){
      width: 100%;
      height: 50px;
      line-height: 50px;
      border: none;
      border-radius: 7px;
      padding-left: 4%;
      font-size: 17px;
  }

  input::placeholder {
    color: black;
  }

  section {
    max-width: 1300px;
    margin: auto;
    padding-top: 100px;
  }

  select {
      font-size: 17px;
  }

  .mobile footer {
    font-size: 15px;
    height: auto;
    text-align: center;
    padding: 0 5px;
    float: left;
    position: unset;
  }

  .mobile #content-section {
    width: 100%;
    padding: 15px;
    margin: auto;
    box-sizing: border-box;
  }

  .mobile #footer-content h3 {
    margin: 5px 0
  }

  .mobile #footer-content ul {
    font-size: 15px;
  }

  .mobile #links {
    width: 100%;
    margin-bottom: 5px;
  }

  .nav-buttons {
    width: 208px;
    font-size: 17px;
    color: #244148;
    text-align: center;
    background-color: white;
    padding: 2px;
    margin-right: 5px;
    line-height: 24px;
    border: 0.5px solid black;
    border-radius: 30px;
    display: inline-block;
    text-decoration: none;
  }

  .nav-buttons:hover {
    background-color: #eee;
  }

  .tablet #footer-content h3 {
    margin-bottom: 0
  }

  .textInput {
    width: 95% !important;
    padding-left: 5% !important;
  }

  .vdp-datepicker {
    width: 100%;
  }

  .vdp-datepicker*{
    width: 100% !important;
  }

  #app {
    height: 100%;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #app-header {
      height: 100px;
      width: 100%;
      background: #8cb6c0;
      position: fixed;
      top: 0;
      z-index: 1;
    }

  #app-header > div {
      height: 100%;
      max-width: 1280px;
      margin: auto;
      padding: 0 20px;
  }

  #cardExp {
    padding-left: 25px !important;
  }

  #city-image {
    width: inherit;
  }

  #content-section {
    width: 50%;
    float: left;
    padding: 70px 0 0 10%;
  }

  #flowbird-logo {
    height: 100%;
  }

  #footer-content {
    height: 100%;
    line-height: 100%;
    max-width: 1280px;
    margin: auto;
  }

  #footer-content a {
    color: white;
    text-decoration: none;
  }

  #footer-content h2 {
    margin: 25px 0 14px 0;
  }

  #footer-content p {
    margin: 0;
  }

  #footer-content ul {
    position: relative;
    bottom: 0;
    list-style: none;
    font-size: 17px;
    margin: 0;
    padding: 0;
  }

  #footer-content div,
  #footer-content li,
  #media *{
    display: inline-block;
  }

  #image-section {
    width: 250px;
    float: left;
  }

  #links {
    width: 45%;
    text-align: center;
  }

  #media {
    vertical-align: bottom;
  }

  #links li:not(:last-child) {
    border-right: 1px solid white;
    padding-right: 10px;
    margin-right: 4px;
  }

  #locale-switcher {
    float: right;
  }

  #media * {
    padding-right: 2px;
  }

  #media i {
    font-size: 25px;
  }

  #nav {
    float: right;
    padding-top: 35px;
    width: 70%;
  }

  @media (min-height: 1161px){
    #image-section {
      width: 315px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue